<div style="height: 100%; overflow: auto;">
    @if (originalRequest) {
        <h3 class="task-widget-title">
            My @if (originalRequest.ShowChoice == 3) {
            <span>Team's </span>
        }Tasks Due Within 45 Days
        </h3>
    }
    @if (taskSeriesTypeList && taskSeriesTypeList.length === 0 && !actionViewTimeout) {
        <p>
            No current tasks
        </p>
    }
    @if (actionViewTimeout) {
        <p class="text-center lead" style="margin-top:20px;">
            Your data is taking some time to load. To access your Action Views,
            <span class="anchor-style" (click)="goToActionView()">click here</span>.
        </p>
    }
    <div class="action-view-overview">
        @if (taskSeriesTypeList && taskSeriesTypeList.length !== 0 && !actionViewTimeout) {
            <table class="task-table">
                <tr>
                    <th></th>
                    @for (headerItem of taskSeriesTypeList[0].data; track headerItem) {
                        <th>{{ headerItem.label }}</th>
                    }
                </tr>
                @for (taskSeriesTypeItem of taskSeriesTypeList; track taskSeriesTypeItem) {
                    <tr>
                        <td class="task-series-row-header">{{ taskSeriesTypeItem.taskSeriesTypeName }}</td>
                        @for (taskCountItem of taskSeriesTypeItem.data; track taskCountItem) {
                            <td [className]="taskCountItem.colClass">
                                <span class="wide-value-badge">
                                    @if (taskCountItem.ready > 0) {
                                        <span (click)="drilldownCell(taskCountItem, 'ready', taskSeriesTypeItem)">{{ taskCountItem.ready }}</span>
                                    }
                                    @if (taskCountItem.notReady > 0) {
                                        <span (click)="drilldownCell(taskCountItem, 'not ready', taskSeriesTypeItem)">({{ taskCountItem.notReady }})</span>
                                    }
                                </span>
                            </td>
                        }
                    </tr>
                }
            </table>
        }
    </div>
</div>
